@let origin = originSg();
@let unit = unitSg();

<atn-summit-allocation-graph-base-overlay [origin]="origin">
  <h4 class="atn-summit-allocation-graph-unit-overlay__name">
    {{ unit.name }}
  </h4>
  @if (unit.description) {
    <p class="atn-summit-allocation-graph-unit-overlay__description">
      {{ unit.description }}
    </p>
  }
</atn-summit-allocation-graph-base-overlay>
